// src/features/owner/charts/ChangeBadge.tsx — inline trend indicator (up/down/flat) for KPI cards.
import styled from 'styled-components';
import type { KpiTrend } from '@/core/models';

const Span = styled.span<{ $trend: KpiTrend }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme, $trend }) =>
    $trend === 'up'
      ? theme.color.success
      : $trend === 'down'
        ? theme.color.danger
        : theme.color.textMuted};
`;

export function ChangeBadge({ deltaPct, trend }: { deltaPct: number | null; trend: KpiTrend }) {
  const glyph = trend === 'up' ? '↗' : trend === 'down' ? '↘' : '→';
  return (
    <Span $trend={trend}>
      {glyph}
      {deltaPct != null ? ` ${Math.abs(deltaPct)}%` : ''}
    </Span>
  );
}
